import * as echarts from 'echarts/core'
import { BarChart, LineChart, PieChart } from 'echarts/charts'
import {
 GridComponent,
 TooltipComponent,
 LegendComponent,
 DatasetComponent,
 TitleComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

let registered = false

export function registerECharts(): typeof echarts {
 if (!registered) {
  echarts.use([
   BarChart,
   LineChart,
   PieChart,
   GridComponent,
   TooltipComponent,
   LegendComponent,
   DatasetComponent,
   TitleComponent,
   CanvasRenderer,
  ])
  registered = true
 }
 return echarts
}

export { echarts }
